import { useEffect, useRef, useState } from "react";
import classNames from "classnames";

import PlusIcon from "../../../assets/svg/plus.svg";

import VtrgPanel from "./VtrgPanel.jsx";
import styles from "./HoverPanel.module.scss";

const HoverPanel = ({
  instanceType,
  instanceId,
  updatePiece,
  setActionLoading,
  afterUpdateVtrgPiece,
  afterSlot, // слот блока, после которого стоит эта панель
  isActive, // эта панель — последняя открытая панель добавления на странице
  onActivate,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  // Открыта форма создания блока — уход курсора больше не закрывает панель
  // (например, при выборе файла в диалоге курсор всегда уходит)
  const [isFormOpen, setIsFormOpen] = useState(false);
  // Слот последнего блока, созданного через эту панель в текущей пачке
  const lastCreatedSlot = useRef(null);

  const openPanel = () => {
    lastCreatedSlot.current = null;
    setShowPanel(true);
    onActivate();
  };

  // Открыли добавление блока в другом месте страницы — закрываемся
  useEffect(() => {
    if (!isActive) {
      setIsFormOpen(false);
      setShowPanel(false);
    }
  }, [isActive]);

  // Курсор к этому моменту обычно уже не над панелью, а mouseleave при смене
  // размеров элемента может не прийти — поэтому сбрасываем ховер вручную
  const closePanel = () => {
    setIsFormOpen(false);
    setShowPanel(false);
    setIsHovered(false);
  };

  // Форма закрылась (создание или «Отмена») — сбрасываем панель целиком
  const onFormChange = (isOpen) => {
    if (isOpen) {
      setIsFormOpen(true);
    } else {
      closePanel();
    }
  };

  // Форма может создать несколько блоков подряд (vtrg_centered_image):
  // первый встаёт после afterSlot, каждый следующий — после предыдущего созданного.
  // final: false — пачка ещё не закончена или были ошибки, панель не закрываем.
  // Возвращает промис перестановки, чтобы форма дождалась её перед следующим блоком
  const afterCreatePiece = (data, { final = true } = {}) => {
    const insertAfter = lastCreatedSlot.current ?? afterSlot;
    if (data) {
      lastCreatedSlot.current = data.slot;
    }

    if (final) {
      closePanel();
    }

    return afterUpdateVtrgPiece(data, insertAfter);
  };

  return (
    <div
      // vtrg-hover-panel / is--open — глобальные классы: по ним в old_vitrage_styles.scss
      // гасится ховер блока, внутри которого лежит панель
      className={classNames(
        "vtrg-hover-panel",
        styles.HoverPanel,
        showPanel && ["is--open", styles.HoverPanelWithForm],
      )}
      // mousemove, а не mouseenter: если курсор остался над панелью после её закрытия,
      // кнопка снова покажется при первом движении мыши
      onMouseMove={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        if (!isFormOpen) {
          setShowPanel(false);
        }
      }}
    >
      {!showPanel && (
        <div className={styles.ButtonWrapper}>
          <button className={styles.Button} onClick={openPanel}>
            <div
              className={classNames(styles.Line, isHovered && styles.LineShow)}
            ></div>

            <div
              className={classNames(
                styles.IconWrapper,
                isHovered && styles.IconWrapperShow,
              )}
            >
              <img src={PlusIcon} alt="" />
            </div>
          </button>
        </div>
      )}

      {showPanel && (
        <div className={styles.Panel}>
          <VtrgPanel
            instanceType={instanceType}
            instanceId={instanceId}
            updatePiece={updatePiece}
            setActionLoading={setActionLoading}
            afterUpdateVtrgPiece={afterCreatePiece}
            onFormChange={onFormChange}
          />
        </div>
      )}
    </div>
  );
};

export default HoverPanel;
